import { BASE_URL } from "../utils/constants";
import { postRequest } from "./api.helper";

export const MAX_VOICE_DURATION_SECONDS = 180;
const DEFAULT_VOICE_PUBLIC_BASE_URL =
  "https://riyatechmatrimony.s3.ap-south-1.amazonaws.com";

const VOICE_PUBLIC_BASE_URL = (
  (import.meta.env as Record<string, string | undefined>)
    .VITE_VOICE_PUBLIC_BASE_URL || DEFAULT_VOICE_PUBLIC_BASE_URL
).replace(/\/+$/, "");

export const resolveVoiceMessageUrl = (value?: string | null) => {
  const raw = String(value || "").trim();
  if (!raw) return "";

  if (
    raw.startsWith("http://") ||
    raw.startsWith("https://") ||
    raw.startsWith("blob:") ||
    raw.startsWith("data:")
  ) {
    return raw;
  }

  if (raw.startsWith("/uploads/")) {
    return `${BASE_URL}${raw}`;
  }

  if (raw.startsWith("uploads/")) {
    return `${BASE_URL}/${raw}`;
  }

  if (raw.startsWith("/voice-messages/")) {
    return `${VOICE_PUBLIC_BASE_URL}${raw}`;
  }

  if (raw.startsWith("voice-messages/")) {
    return `${VOICE_PUBLIC_BASE_URL}/${raw}`;
  }

  return raw;
};

export const uploadVoiceMessage = async (file: File, profileId: string) => {
  const response = await postRequest("/admin/profile/voice-upload-url", {
    profileId,
    fileName: file.name,
    contentType: file.type || "audio/webm",
  });

  if (!response.success || !response.data?.uploadUrl || !response.data?.fileUrl) {
    throw new Error(response.message || "Unable to prepare voice upload.");
  }

  const uploadResponse = await fetch(response.data.uploadUrl, {
    method: "PUT",
    headers: {
      "Content-Type": file.type || "audio/webm",
    },
    body: file,
  });

  if (!uploadResponse.ok) {
    throw new Error("Voice upload failed.");
  }

  return {
    fileUrl: response.data.fileUrl as string,
    key: response.data.key as string | undefined,
  };
};
